import React, { useState } from 'react';
import AdapexOrGPTSlot from '../../common/AdapexOrGPTSlot';
const AdBoxPinnedInline = ({ params, appContext }) => {
    const { app_id, page_url } = params;
    const [rendered, setRendered] = useState(true);
    const slotProps = {
        appContext,
        params,
        app_id: app_id !== null && app_id !== void 0 ? app_id : '',
        id: 'div-21796380238-fwn-widget-pinned-inline',
        path: `/21796380238/${app_id !== null && app_id !== void 0 ? app_id : ''}`,
        page_url: page_url !== null && page_url !== void 0 ? page_url : '',
        size: [
            [250, 250],
            [300, 250],
        ],
        style: {
            marginRight: '10px',
        },
        targeting: [
            ['app_id', [app_id !== null && app_id !== void 0 ? app_id : '']],
            ['page_url', [page_url !== null && page_url !== void 0 ? page_url : '']],
        ],
        onError: () => setRendered(false),
    };
    return rendered ? <AdapexOrGPTSlot {...slotProps}/> : null;
};
export default AdBoxPinnedInline;
